export default __webpack_public_path__ + "media/images/icon_direct-d49ac99c0152da6f9eb29ef8f7e1c7af.png";